export const generateQueryFromString = queryString => {
  const search = queryString?.startsWith('?') ? queryString.slice(1) : queryString;

  if (!search) {
    return {};
  }

  const arr = search.split('&');
  let obj = {};
  let currentKey = null;

  for (let item of arr) {
    if (!item) {
      continue;
    }

    const separatorIndex = item.indexOf('=');

    if (separatorIndex === -1) {
      if (currentKey) {
        obj = {
          ...obj,
          [currentKey]: `${obj[currentKey]}&${item}`
        };
      }

      continue;
    }

    const key = item.slice(0, separatorIndex);
    const value = item.slice(separatorIndex + 1);

    if (key) {
      currentKey = key;
      obj = {
        ...obj,
        [key]: value
      };
    }
  }

  return obj;
};

export const generateQueryString = (queryParams, useCurrentQuery = true) => {
  const currentQuery = getCurrentQuery();

  if (useCurrentQuery) return generateString({ ...currentQuery, ...queryParams });
  else return generateString({ ...queryParams });
};

export const generateMobileQueryString = queryParams => {
  return generateString(queryParams);
};

export const removeFromQueryString = key => {
  const currentQuery = getCurrentQuery();
  delete currentQuery[key];

  return generateString(currentQuery);
};

const getCurrentQuery = () => generateQueryFromString(window.location.search);

const generateString = queryParams => {
  let query = '';

  for (let key of Object.keys(queryParams)) {
    if (!query) query += '?';
    else query += '&';

    query += `${key}=${queryParams[key]}`;
  }

  return query;
};

export const getParameterByName = (name, url) => {
  name = name.replace(/\[]]/g, '\\$&');
  let regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
    results = regex.exec(url);
  if (!results) return null;
  if (!results[2]) return '';
  return decodeURIComponent(results[2].replace(/\+/g, ' '));
};